import {FirstSection} from "@/pages/news/sections/FirstSection";
import {SecondSection} from "@/pages/news/sections/SecondSection/SecondSection";
import {ThirdSection} from "@/pages/news/sections/ThirdSection/ThirdSection";
import FadeInWhenVisible from "@/components/animations/FadeInWhenVisible";
import {MBThirdSection} from "@/pages/news/sections/MBThirdSection/MBThirdSection";

const NewsPage = () => {
    return (
        <FadeInWhenVisible>
            <div className={"container lg:px-24 px-10 mx-auto justify-center space-y-10 p-4"}>
                <FirstSection/>
                <SecondSection/>
                <ThirdSection/>
                <MBThirdSection/>
            </div>
        </FadeInWhenVisible>
    )
}
export default NewsPage;